import { useEffect, useState, useCallback, useRef } from "react";
import { createPortal } from "react-dom";
import { ModelWindowStyles } from "./ModelWindow.styled";

export const ModelWindow = ({ children, onClose, isOpen }) => {
  const modelRoot = document.getElementById("model-root") || document.body;
  const [isClosing, setIsClosing] = useState(false);

  // ✅ робимо ref, щоб не втрачати актуальний onClose без залежностей
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  const handleClose = useCallback(() => {
    setIsClosing(true);
    setTimeout(() => {
      onCloseRef.current?.();
      setIsClosing(false); // очищаємо локальний стан
    }, 250); // тривалість анімації slideOut
  }, []);

  useEffect(() => {
    const closeESCButton = (evt) => {
      if (evt.code === "Escape") {
        handleClose();
      }
    };

    document.body.style.overflowY = "hidden";
    document.addEventListener("keydown", closeESCButton);

    return () => {
      document.body.style.overflowY = "scroll";
      document.removeEventListener("keydown", closeESCButton);
    };
  }, [handleClose]);

  if (!isOpen && !isClosing) return null;

  return createPortal(
    <ModelWindowStyles
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          handleClose();
        }
      }}
      $isClosing={isClosing}
    >
      {children}
    </ModelWindowStyles>,
    modelRoot
  );
};
